module.exports = __webpack_public_path__ + "img/smart-scan-char-3.c4a04366.png";